import React from "react";
import styled from "styled-components/macro";
import { device, toRem } from "theme/Breakpoints";
import { DefaultText } from "theme/GlobalElements";

interface ServiceBarItemDesktopProps {
  text: string;
  icon: any;
}

const ServiceBarItemDesktop: React.FC<ServiceBarItemDesktopProps> = ({
  icon,
  text,
}) => {
  return (
    <SVGItem>
      <SVGImg src={icon} />
      <Text className="text-sm">{text}</Text>
    </SVGItem>
  );
};

const SVGItem = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  flex: 1 25%;
  color: white;
  margin-bottom: 20px;

  &last-child {
    margin-bottom: 0;
  }
  @media only screen and (${device.tablet}) {
    flex-flow: row nowrap;
    margin-bottom: 0;
    margin-right: 10px;
  }
`;

const SVGImg = styled.img`
  width: 32px;
  height: 32px;
  margin-bottom: 5px;
  @media only screen and (${device.tablet}) {
    margin-right: 10px;
    width: 48px;
    height: 48px;
  }
`;
const Text = styled(DefaultText)`
  text-align: center;
  font-weight: 700;
  color: white;

  @media only screen and (${device.tablet}) {
    text-align: left;
  }
`;

export default ServiceBarItemDesktop;
